import { SquidexDate } from "../services";

export class SquidexTool {

  public sanitizeForUniqueName(name: string) {
    return this.cleanString(name);
  }

  public firstUpperSnakeCase(str: string) {
    if (!str) {
      return '';
    } else {
      let result = str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('_');
      return str.charAt(0).toUpperCase() + result.slice(1);
    }
  }

  // force lowercase and allow hyphen (or not)
  public makeSlug(str: string, noHyphen: boolean = false) {
    str = str.toLowerCase();
    const replaceChar = noHyphen ? '' : '-';
    str = str.replace(/[^a-z0-9]+/g, replaceChar);
    str = str.replace(/^-+|-+$/g, '');
    return str;
  }

  // uppercase 1st char, remove spaces and unnecessary characters.  don't force underscore but allow it
  public cleanString(str: string) {
    if (!str) {
      return '';
    } else {
      let result = str.replace(/[^a-zA-Z0-9_]+/g, "");
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
  }

  public dateStringToUtc(date: string) {
    const dt = new Date(date);
    return new SquidexDate(dt).formatUtc().slice(0,-5) + 'Z';
  }

  public utcToDateString(date: string) {
    const dt = new Date(date);

    return dt.getFullYear() +
      '-' + this.pad(dt.getMonth() + 1) +
      '-' + this.pad(dt.getDate()) +
      'T' + this.pad(dt.getHours()) +
      ':' + this.pad(dt.getMinutes()) +
      ':' + this.pad(dt.getSeconds()) +
      'Z';
  }

  private pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

}
